import { Banner, Button, Text } from "@shopify/polaris"
import classNames from "classnames"
import { observer } from "mobx-react"
import { useState } from "react"

import stores from "@/stores"

import StepHeader from "../components/StepHeader"
import { getCategoryOptions, getRegionOptions } from "../config"

const StepOne = observer((props: { onContinue: () => void }) => {
  const { onContinue } = props
  const onboarding = stores.OnboardingStore
  const [categoryError, setCategoryError] = useState(false)
  const [regionError, setRegionError] = useState(false)

  const handleContinue = async () => {
    const hasCategory = onboarding.selectedCategories.length > 0
    const hasRegion = onboarding.selectedRegions.length > 0
    setCategoryError(!hasCategory)
    setRegionError(!hasRegion)
    if (!hasCategory || !hasRegion) return

    onboarding.saveStep1()
    onContinue()
  }

  return (
    <>
      <StepHeader
        description={t("TellUsAboutStoreSoCanConfigureEverything")}
        title={t("LetsSetUpReturnCenter")}
      />
      <div className="flex flex-col gap-7">
        <div className="flex flex-col gap-2">
          <Text as="p" tone="subdued" variant="bodyMd">
            {t("WhatSell")}
          </Text>
          {categoryError && (
            <Banner tone="critical">
              <p>{t("PleaseSelectLeastOneProductCategoryConti")}</p>
            </Banner>
          )}
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
            {getCategoryOptions().map((item) => {
              const isSelected = onboarding.selectedCategories.includes(
                item.value,
              )

              return (
                <button
                  className={classNames(
                    "category-card flex h-[92px] cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border border-solid p-3 transition-all",
                    isSelected
                      ? "border-[#1274ff] bg-[#e7f1ff] selected"
                      : "border-[var(--p-color-border)] bg-[var(--p-color-bg-surface)] hover:border-[var(--p-color-border-hover)] hover:bg-[var(--p-color-bg-surface-hover)]",
                  )}
                  key={item.value}
                  onClick={() => onboarding.toggleCategory(item.value)}
                  type="button"
                >
                  <span className="text-[30px] leading-10">{item.icon}</span>
                  <span className="text-[13px] leading-5 text-[var(--p-color-text)]">
                    {item.label}
                  </span>
                </button>
              )
            })}
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <Text as="p" tone="subdued" variant="bodyMd">
            {t("WhereCustomers")}
          </Text>
          {regionError && (
            <Banner tone="critical">
              <p>{t("PleaseSelectLeastOneCustomerRegionContin")}</p>
            </Banner>
          )}
          <div className="flex flex-wrap items-center gap-3">
            {getRegionOptions().map((item) => {
              const isSelected = onboarding.selectedRegions.includes(item.value)

              return (
                <button
                  style={{ boxSizing: "unset" }}
                  className={classNames(
                    "category-card h-8 cursor-pointer rounded-3xl border border-solid px-3 leading-5 transition-all",
                    isSelected
                      ? "border-[#1274ff] bg-[#e7f1ff] text-[#0067ff] selected"
                      : "border-[var(--p-color-border)] bg-[var(--p-color-bg-surface)] text-[var(--p-color-text)] hover:border-[var(--p-color-border-hover)] hover:bg-[var(--p-color-bg-surface-hover)]",
                  )}
                  key={item.value}
                  onClick={() => onboarding.toggleRegion(item.value)}
                  type="button"
                >
                  {item.label}
                </button>
              )
            })}
          </div>
        </div>
      </div>
      <div className="flex justify-end">
        <div className="blueButton">
          <Button
            disabled={onboarding.isSaving}
            loading={onboarding.isSaving}
            onClick={handleContinue}
            variant="tertiary"
          >
            {t("Continue_0")}
          </Button>
        </div>
      </div>
    </>
  )
})

export default StepOne
